import React from "react";
import { IPolicyFeature } from "../../../../../interfaces/IPolicyFeature";
import Icon from "../../../../../../common/components/Icon/Icon";
import ToolTip from "../../../../../../common/components/Tooltips/Tooltip";

// styles
import cx from "classnames";

interface IQuoteTableFullCardFeatureProps {
    feature: IPolicyFeature;
    className?: string;
}

const QuoteTableFullCardFeature: React.FC<IQuoteTableFullCardFeatureProps> = (props) => {
    const { sectionName, detail, detailMore, tooltip } = props.feature;

    const isIcon = ["[Tick]", "[Cross]", "Partial"].includes(detail);

    return (
        <div
            className={cx("layout-flex-row--baseline", {
                [props.className]: !!props.className
            })}>
            {isIcon && (
                <div className="space-m">
                    {detail === "[Tick]" && <Icon id="SaveTick" />}
                    {detail === "[Cross]" && <Icon id="RedCross" />}
                    {detail === "Partial" && !detailMore && <Icon id="SliderMinus" />}
                </div>
            )}
            <div className={cx("text-small", "layout-flex-column")}>
                <div className={cx("layout-flex-row")}>
                    <span
                        className={cx("space-m", "title-quote-card", {
                            ["text-negative"]: detail === "[Cross]"
                        })}>
                        {sectionName}
                    </span>
                    {tooltip && (
                        <ToolTip
                            tooltipContent={
                                <React.Fragment>
                                    <p>{tooltip}</p>
                                    <p>
                                        Cover varies between plans. Please see the policy
                                        document for full details.
                                    </p>
                                </React.Fragment>
                            }
                        />
                    )}
                </div>
                <div>
                    {!isIcon && detail && <span>{detail}</span>}
                    {detailMore && (
                        <span>
                            {detail ? " " : ""}
                            {detailMore}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default QuoteTableFullCardFeature;
